module.exports = __webpack_public_path__ + "static/common-data-elements-banner-overlay-6cbf4bc83674ab49916452e9833e3cca.jpg";